import TagManager from "react-gtm-module";

function SchoolSearchLocation({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "school_search_location",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default SchoolSearchLocation;
